import React, { useState, useEffect } from "react";
import { Menu, X, Phone, Scale } from "lucide-react";
import { navLinks, firm } from "../mock/mock";
import { Button } from "./ui/button";
import PaymentDialog from "./PaymentDialog";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#14213d]/95 backdrop-blur-md shadow-lg py-3"
          : "bg-transparent py-5"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-3 group">
          <span className="flex items-center justify-center w-10 h-10 rounded-md bg-[#c8a15a] text-[#14213d] transition-transform group-hover:scale-105">
            <Scale size={22} strokeWidth={2.2} />
          </span>
          <span className="leading-tight">
            <span className="block font-display text-lg md:text-xl font-700 text-white tracking-wide">
              {firm.name}
            </span>
            <span className="block text-[10px] md:text-xs uppercase tracking-[0.2em] text-[#c8a15a]">
              {firm.title}
            </span>
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm font-medium text-slate-200 hover:text-[#c8a15a] transition-colors relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[#c8a15a] after:transition-all hover:after:w-full"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <PaymentDialog />
          <a href={firm.phoneHref}>
            <Button className="bg-[#c8a15a] hover:bg-[#b58f45] text-[#14213d] font-semibold gap-2">
              <Phone size={16} /> {firm.phone}
            </Button>
          </a>
        </div>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-[#14213d] border-t border-white/10 mt-3">
          <div className="px-6 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setOpen(false)}
                className="text-slate-200 hover:text-[#c8a15a] font-medium"
              >
                {link.label}
              </a>
            ))}
            <div className="flex flex-col gap-3 pt-2">
              <PaymentDialog />
              <a href={firm.phoneHref}>
                <Button className="w-full bg-[#c8a15a] hover:bg-[#b58f45] text-[#14213d] font-semibold gap-2">
                  <Phone size={16} /> {firm.phone}
                </Button>
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
